import { useState, useEffect } from 'react';
import { settingsAPI } from '../services/api';
import socketService from '../services/socket';

export const useSettings = () => {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchSettings = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await settingsAPI.getAll();
            setSettings(response.data.data.settings);
        } catch (err) {
            console.error('Error fetching settings:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();

        // Connect to Socket.IO for real-time settings updates
        socketService.connect();

        const handleSettingUpdated = (data) => {
            setSettings(prev => ({
                ...prev,
                [data.key]: data.value
            }));
        };

        const handleSettingDeleted = (data) => {
            setSettings(prev => {
                const newSettings = { ...prev };
                delete newSettings[data.key];
                return newSettings;
            });
        };

        socketService.onSettingUpdated(handleSettingUpdated);
        socketService.onSettingDeleted(handleSettingDeleted);

        return () => {
            socketService.offSettingUpdated(handleSettingUpdated);
            socketService.offSettingDeleted(handleSettingDeleted);
        };
    }, []);

    const getSetting = (key, defaultValue = null) => {
        return settings[key] !== undefined ? settings[key] : defaultValue;
    };

    const getDeliveryLimit = () => {
        return getSetting('deliveryLimit', parseFloat(import.meta.env.VITE_DELIVERY_LIMIT) || 10);
    };

    const getDeliveryCharge = () => {
        return getSetting('deliveryCharge', 50);
    };

    const getFreeDeliveryThreshold = () => {
        return getSetting('freeDeliveryThreshold', 500);
    };

    const getBusinessInfo = () => {
        return {
            name: getSetting('businessName', 'Grainly'),
            phone: getSetting('businessPhone', ''),
            address: getSetting('businessAddress', '')
        };
    };

    return {
        settings,
        loading,
        error,
        fetchSettings,
        getSetting,
        getDeliveryLimit,
        getDeliveryCharge,
        getFreeDeliveryThreshold,
        getBusinessInfo
    };
};

export default useSettings;